import axios from 'axios'
import router from '../../../router'
import store from "../../../store/index.js";
import moduleService from "../../../services/module-service"

const GLOBAL_SEARCH_INDEX = "globalSearch";

export default {

    getSearchResults(searchString) {

        return axios.get('/rest/v4/globalsearch', {
            params: {
                search: searchString
            }
        })
    },

    getSearchResultsByIndex(search, searchIndex, page, size, sortingFilter) {
        return axios.get('/rest/v4/globalsearch', {
            params: {
                search,
                modules: searchIndex,
                page,
                size,
                sortingFilter
            }
        })
    },

    routeToTargetModule() {
        const searchIndex = store?.state?.search?.searchIndex;
        if (searchIndex == undefined || searchIndex === GLOBAL_SEARCH_INDEX) {
            router.push("/search").catch(() => { });
        }

        var link = moduleService.getRouterLinkByIndex(store.state.search.searchIndex);
        router.push(link).catch(() => { });
    },

    async routeToGlobalSearch() {
        const GLOBAL_SEARCH_PATH = '/search';

        return router.push(GLOBAL_SEARCH_PATH).catch(() => {});
    }
}
